import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ParkbaseStorageService } from 'src/app/@shared/services/parkbaseStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { FacilitySummaryGrouped } from 'src/app/@core/domain/interfaces/facility-summary.interface';
import { Division } from 'src/app/@core/domain/interfaces/division.interface';
import { DivisionsApiService } from 'src/app/@core/api/divisions-api.service';
import { FacilitiesApiService } from 'src/app/@core/api/facilities-api.service';
import { LogService } from 'src/app/@core';
import { StatusPageService } from '../../services/status-page.service';
import { NbDialogService, NbLayoutRulerService } from '@nebular/theme';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacilitiesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() facilitySelection!: string;
  @Input() facilityId!: number;

  selection = 'divisionsNotifications';
  selectedLayout = '';
  division$: Observable<Division>;
  facilitySummaryGrouped!: Observable<FacilitySummaryGrouped>;
  loading = true;
  interval = 50000;
  toggleNotifications = false;
  showNotificationsContainer = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private divisionsApiService: DivisionsApiService,
    private facilitiesApiService: FacilitiesApiService,
    private dialogService: NbDialogService,
    private statusPageService: StatusPageService,
    private parkbaseStorageService: ParkbaseStorageService,
    private layoutRuleService: NbLayoutRulerService,
    private translate: TranslateService,
    private logger: LogService
  ) {
    this.interval = setInterval(() => {
      this.refresh();
    }, environment.refreshInterval);
    this.division$ = this.divisionsApiService.division$;
    this.divisionsApiService.loadDivisions();

    this.facilitySelection = this.selection;

    this.getWindowSize();
  }

  refresh(): void {
    this.facilitiesApiService.loadFacilitySummaryGrouped();
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.getWindowSize();
  }

  getWindowSize() {
    this.layoutRuleService.getDimensions().subscribe((data) => {
      this.showNotificationsContainer = data.clientWidth >= 1440;
    });
  }

  ngOnInit(): void {
    this.facilitySummaryGrouped = this.facilitiesApiService.facilitySummaryGrouped;
    this.facilitiesApiService.loadFacilitySummaryGrouped();
    this.selectedLayout = this.parkbaseStorageService.retrieveStatusPageLayout();

    this.statusPageService.refreshFacilitiesSummary.subscribe((status) => {
      if (status) {
        this.facilitiesApiService.loadFacilitySummaryGrouped();
      }
    });

    this.route.params.subscribe((params: Params) => {
      if (Object.keys(params).length === 0) {
        const facilityOptionAll = { id: 0, name: '', availableActions: [] };
        this.translate.get('FACILITY_SELECT.OPTION_ALL').subscribe((res: string) => {
          if (res) {
            facilityOptionAll.name = res;
          }
        });
        this.parkbaseStorageService.storeFacilitySelection(facilityOptionAll);
      }
    });
  }

  ngAfterViewInit() {
    this.facilitySummaryGrouped.subscribe((data) => {
      if (Object.keys(data).length === 0) {
        this.facilitiesApiService.loadFacilitySummaryGrouped();
      }
    });
  }

  showNotifications() {
    this.toggleNotifications = !this.toggleNotifications;
    this.logger.info('Notifications window on status page opened');
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  trackByFn(index: number): number {
    return index;
  }
}
